<div class="header">
    <h2 class="logo"><i class="fa fa-film" aria-hidden="true"></i>&nbsp;Fan-nation</h2>
</div>